import Phaser from 'phaser';

/**
 * 子弹（对象池化）
 * - 由 GameScene 的 physics group 复用，避免每次都 new + destroy 造成 GC 抖动
 * - 支持穿透（pierce）与暴击标记
 * - 超出存活时间由 GameScene 通过 shotCount 令牌安全回收
 */
export default class Bullet extends Phaser.Physics.Arcade.Sprite {
  damage = 25;
  pierce = 0;
  crit = false;
  /** 每次发射自增，用于判断延迟回收时该子弹是否已被复用 */
  shotCount = 0;

  constructor(scene: Phaser.Scene, x: number, y: number, key: string = 'bullet') {
    super(scene, x, y, key);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setImmovable(true);
    (this.body as Phaser.Physics.Arcade.Body).allowGravity = false;
    this.body?.setSize(8, 8);
    this.setOrigin(0.5, 0.5);
    if (key && scene.textures.exists(key)) this.setTexture(key);
    this.deactivate();
  }

  launch(
    x: number,
    y: number,
    angle: number,
    speed: number,
    damage: number,
    pierce: number,
    crit: boolean,
    textureKey: string = 'bullet'
  ) {
    this.shotCount += 1;
    // 对象池复用时必须显式重设贴图：Phaser 的 Group.get() 会传入 defaultKey（可能为 null），
    // 而 null 不会触发构造函数里的默认参数，导致贴图变成 __MISSING。
    this.setTexture(textureKey);
    this.setActive(true).setVisible(true);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.enable = true;
    body.reset(x, y);
    body.allowGravity = false;
    this.damage = damage;
    this.pierce = pierce;
    this.crit = crit;
    this.setAngle(Phaser.Math.RadToDeg(angle));
    this.setTint(crit ? 0xffef7a : 0xffffff);
    body.setVelocity(Math.cos(angle) * speed, Math.sin(angle) * speed);
  }

  deactivate() {
    this.setActive(false).setVisible(false);
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (body) {
      body.stop();
      body.enable = false;
    }
  }
}
